function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { evalCondition } from "./mongrule.mjs";
import { chooseVariation, decrypt, getBucketRanges, getQueryStringOverride, getUrlRegExp, hash, inNamespace, inRange, isIncluded, isURLTargeted, toString } from "./util.mjs";
export var EVENT_FEATURE_EVALUATED = "Feature Evaluated";
export var EVENT_EXPERIMENT_VIEWED = "Experiment Viewed";
function getForcedFeatureValues(ctx) {
  // Merge user and global values
  var ret = new Map();
  if (ctx.global.forcedFeatureValues) {
    ctx.global.forcedFeatureValues.forEach(function (v, k) {
      return ret.set(k, v);
    });
  }
  if (ctx.user.forcedFeatureValues) {
    ctx.user.forcedFeatureValues.forEach(function (v, k) {
      return ret.set(k, v);
    });
  }
  return ret;
}
function getForcedVariations(ctx) {
  // Merge user and global values
  if (ctx.global.forcedVariations && ctx.user.forcedVariations) {
    return _objectSpread(_objectSpread({}, ctx.global.forcedVariations), ctx.user.forcedVariations);
  } else if (ctx.global.forcedVariations) {
    return ctx.global.forcedVariations;
  } else if (ctx.user.forcedVariations) {
    return ctx.user.forcedVariations;
  } else {
    return {};
  }
}
function safeCall(_x) {
  return _safeCall.apply(this, arguments);
}
function _safeCall() {
  _safeCall = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(fn) {
    var _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.p = 0;
          _context.n = 1;
          return fn();
        case 1:
          _context.n = 3;
          break;
        case 2:
          _context.p = 2;
          _t = _context.v;
        case 3:
          return _context.a(2);
      }
    }, _callee, null, [[0, 2]]);
  }));
  return _safeCall.apply(this, arguments);
}
function onExperimentViewed(ctx, experiment, result) {
  // Make sure a tracking callback is only fired once per unique experiment
  if (ctx.user.trackedExperiments) {
    var k = getExperimentDedupeKey(experiment, result);
    if (ctx.user.trackedExperiments.has(k)) {
      return [];
    }
    ctx.user.trackedExperiments.add(k);
  }
  if (ctx.user.enableDevMode && ctx.user.devLogs) {
    ctx.user.devLogs.push({
      experiment: experiment,
      result: result,
      timestamp: Date.now().toString(),
      logType: "experiment"
    });
  }
  var calls = [];
  if (ctx.global.trackingCallback) {
    var cb = ctx.global.trackingCallback;
    calls.push(safeCall(function () {
      return cb(experiment, result, ctx.user);
    }));
  }
  if (ctx.user.trackingCallback) {
    var _cb = ctx.user.trackingCallback;
    calls.push(safeCall(function () {
      return _cb(experiment, result);
    }));
  }
  if (ctx.global.eventLogger) {
    var _cb2 = ctx.global.eventLogger;
    calls.push(safeCall(function () {
      return _cb2(EVENT_EXPERIMENT_VIEWED, {
        experimentId: experiment.key,
        variationId: result.key,
        hashAttribute: result.hashAttribute,
        hashValue: result.hashValue
      }, ctx.user);
    }));
  }
  return calls;
}
function onFeatureUsage(ctx, key, ret) {
  // Only track a feature once, unless the assigned value changed
  if (ctx.user.trackedFeatureUsage) {
    var stringifiedValue = JSON.stringify(ret.value);
    if (ctx.user.trackedFeatureUsage[key] === stringifiedValue) return;
    ctx.user.trackedFeatureUsage[key] = stringifiedValue;
    if (ctx.user.enableDevMode && ctx.user.devLogs) {
      ctx.user.devLogs.push({
        featureKey: key,
        result: ret,
        timestamp: Date.now().toString(),
        logType: "feature"
      });
    }
  }
  if (ctx.global.onFeatureUsage) {
    var cb = ctx.global.onFeatureUsage;
    safeCall(function () {
      return cb(key, ret, ctx.user);
    });
  }
  if (ctx.user.onFeatureUsage) {
    var _cb3 = ctx.user.onFeatureUsage;
    safeCall(function () {
      return _cb3(key, ret);
    });
  }
  if (ctx.global.eventLogger) {
    var _cb4 = ctx.global.eventLogger;
    safeCall(function () {
      return _cb4(EVENT_FEATURE_EVALUATED, {
        feature: key,
        source: ret.source,
        value: ret.value,
        ruleId: ret.source === "defaultValue" ? "$default" : ret.ruleId || "",
        variationId: ret.experimentResult ? ret.experimentResult.key : ""
      }, ctx.user);
    });
  }
}
export function evalFeature(id, ctx) {
  if (ctx.stack.evaluatedFeatures.has(id)) {
    process.env.NODE_ENV !== "production" && ctx.global.log("evalFeature: circular dependency detected: ".concat(ctx.stack.id, " -> ").concat(id), {
      from: ctx.stack.id,
      to: id
    });
    return getFeatureResult(ctx, id, null, "cyclicPrerequisite");
  }
  ctx.stack.evaluatedFeatures.add(id);
  ctx.stack.id = id;

  // Global override
  var forcedValues = getForcedFeatureValues(ctx);
  if (forcedValues.has(id)) {
    process.env.NODE_ENV !== "production" && ctx.global.log("Global override", {
      id: id,
      value: forcedValues.get(id)
    });
    return getFeatureResult(ctx, id, forcedValues.get(id), "override");
  }

  // Unknown feature id
  if (!ctx.global.features || !ctx.global.features[id]) {
    process.env.NODE_ENV !== "production" && ctx.global.log("Unknown feature", {
      id: id
    });
    return getFeatureResult(ctx, id, null, "unknownFeature");
  }

  // Get the feature
  var feature = ctx.global.features[id];

  // Loop through the rules
  if (feature.rules) {
    var evaluatedFeatures = new Set(ctx.stack.evaluatedFeatures);
    var _iterator = _createForOfIteratorHelper(feature.rules),
      _step;
    try {
      rules: for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var rule = _step.value;
        // If there are prerequisite flag(s), evaluate them
        if (rule.parentConditions) {
          var _iterator2 = _createForOfIteratorHelper(rule.parentConditions),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var parentCondition = _step2.value;
              ctx.stack.evaluatedFeatures = new Set(evaluatedFeatures);
              var parentResult = evalFeature(parentCondition.id, ctx);
              // break out for cyclic prerequisites
              if (parentResult.source === "cyclicPrerequisite") {
                return getFeatureResult(ctx, id, null, "cyclicPrerequisite");
              }
              var evalObj = {
                value: parentResult.value
              };
              var evaled = evalCondition(evalObj, parentCondition.condition || {});
              if (!evaled) {
                // blocking prerequisite eval failed: feature evaluation fails
                if (parentCondition.gate) {
                  process.env.NODE_ENV !== "production" && ctx.global.log("Feature blocked by prerequisite", {
                    id: id,
                    rule: rule
                  });
                  return getFeatureResult(ctx, id, null, "prerequisite");
                }
                // non-blocking prerequisite eval failed: break out of parentConditions loop, jump to the next rule
                process.env.NODE_ENV !== "production" && ctx.global.log("Skip rule because prerequisite evaluation fails", {
                  id: id,
                  rule: rule
                });
                continue rules;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }

        // If there are filters for who is included (e.g. namespaces)
        if (rule.filters && isFilteredOut(rule.filters, ctx)) {
          process.env.NODE_ENV !== "production" && ctx.global.log("Skip rule because of filters", {
            id: id,
            rule: rule
          });
          continue;
        }

        // Feature value is being forced
        if ("force" in rule) {
          // If it's a conditional rule, skip if the condition doesn't pass
          if (rule.condition && !conditionPasses(rule.condition, ctx)) {
            process.env.NODE_ENV !== "production" && ctx.global.log("Skip rule because of condition ff", {
              id: id,
              rule: rule
            });
            continue;
          }

          // If this is a percentage rollout, skip if not included
          if (!isIncludedInRollout(ctx, rule.seed || id, rule.hashAttribute, ctx.user.saveStickyBucketAssignmentDoc && !rule.disableStickyBucketing ? rule.fallbackAttribute : undefined, rule.range, rule.coverage, rule.hashVersion)) {
            process.env.NODE_ENV !== "production" && ctx.global.log("Skip rule because user not included in rollout", {
              id: id,
              rule: rule
            });
            continue;
          }
          process.env.NODE_ENV !== "production" && ctx.global.log("Force value from rule", {
            id: id,
            rule: rule
          });

          // If this was a remotely evaluated experiment, fire the tracking callbacks
          if (rule.tracks) {
            rule.tracks.forEach(function (t) {
              var calls = onExperimentViewed(ctx, t.experiment, t.result);
              if (!calls.length && ctx.global.saveDeferredTrack) {
                ctx.global.saveDeferredTrack({
                  experiment: t.experiment,
                  result: t.result
                });
              }
            });
          }
          return getFeatureResult(ctx, id, rule.force, "force", rule.id);
        }
        if (!rule.variations) {
          process.env.NODE_ENV !== "production" && ctx.global.log("Skip invalid rule", {
            id: id,
            rule: rule
          });
          continue;
        }

        // For experiment rules, run an experiment
        var exp = {
          variations: rule.variations,
          key: rule.key || id
        };
        if ("coverage" in rule) exp.coverage = rule.coverage;
        if (rule.weights) exp.weights = rule.weights;
        if (rule.hashAttribute) exp.hashAttribute = rule.hashAttribute;
        if (rule.fallbackAttribute) exp.fallbackAttribute = rule.fallbackAttribute;
        if (rule.disableStickyBucketing) exp.disableStickyBucketing = rule.disableStickyBucketing;
        if (rule.bucketVersion !== undefined) exp.bucketVersion = rule.bucketVersion;
        if (rule.minBucketVersion !== undefined) exp.minBucketVersion = rule.minBucketVersion;
        if (rule.namespace) exp.namespace = rule.namespace;
        if (rule.meta) exp.meta = rule.meta;
        if (rule.ranges) exp.ranges = rule.ranges;
        if (rule.name) exp.name = rule.name;
        if (rule.phase) exp.phase = rule.phase;
        if (rule.seed) exp.seed = rule.seed;
        if (rule.hashVersion) exp.hashVersion = rule.hashVersion;
        if (rule.filters) exp.filters = rule.filters;
        if (rule.condition) exp.condition = rule.condition;

        // Only return a value if the user is part of the experiment
        var _runExperiment = runExperiment(exp, id, ctx),
          result = _runExperiment.result;
        ctx.global.onExperimentEval && ctx.global.onExperimentEval(exp, result);
        if (result.inExperiment && !result.passthrough) {
          return getFeatureResult(ctx, id, result.value, "experiment", rule.id, exp, result);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  process.env.NODE_ENV !== "production" && ctx.global.log("Use default value", {
    id: id,
    value: feature.defaultValue
  });

  // Fall back to using the default value
  return getFeatureResult(ctx, id, feature.defaultValue === undefined ? null : feature.defaultValue, "defaultValue");
}
export function runExperiment(experiment, featureId, ctx) {
  var key = experiment.key;
  var numVariations = experiment.variations.length;

  // 1. If experiment has less than 2 variations, return immediately
  if (numVariations < 2) {
    process.env.NODE_ENV !== "production" && ctx.global.log("Invalid experiment", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 2. If the context is disabled, return immediately
  if (ctx.global.enabled === false || ctx.user.enabled === false) {
    process.env.NODE_ENV !== "production" && ctx.global.log("Context disabled", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 2.5. Merge in experiment overrides from the context
  experiment = mergeOverrides(experiment, ctx);

  // 2.6 New, more powerful URL targeting
  if (experiment.urlPatterns && !isURLTargeted(ctx.user.url || "", experiment.urlPatterns)) {
    process.env.NODE_ENV !== "production" && ctx.global.log("Skip because of url targeting", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 3. If a variation is forced from a querystring, return the forced variation
  var qsOverride = getQueryStringOverride(key, ctx.user.url || "", numVariations);
  if (qsOverride !== null) {
    process.env.NODE_ENV !== "production" && ctx.global.log("Force via querystring", {
      id: key,
      variation: qsOverride
    });
    return {
      result: getExperimentResult(ctx, experiment, qsOverride, false, featureId)
    };
  }

  // 4. If a variation is forced in the context, return the forced variation
  var forcedVariations = getForcedVariations(ctx);
  if (key in forcedVariations) {
    var variation = forcedVariations[key];
    process.env.NODE_ENV !== "production" && ctx.global.log("Force via dev tools", {
      id: key,
      variation: variation
    });
    return {
      result: getExperimentResult(ctx, experiment, variation, false, featureId)
    };
  }

  // 5. Exclude if a draft experiment or not active
  if (experiment.status === "draft" || experiment.active === false) {
    process.env.NODE_ENV !== "production" && ctx.global.log("Skip because inactive", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 6. Get the hash attribute and return if empty
  var _getHashAttribute = getHashAttribute(ctx, experiment.hashAttribute, ctx.user.saveStickyBucketAssignmentDoc && !experiment.disableStickyBucketing ? experiment.fallbackAttribute : undefined),
    hashAttribute = _getHashAttribute.hashAttribute,
    hashValue = _getHashAttribute.hashValue;
  if (!hashValue) {
    process.env.NODE_ENV !== "production" && ctx.global.log("Skip because missing hashAttribute", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }
  var assigned = -1;
  var foundStickyBucket = false;
  var stickyBucketVersionIsBlocked = false;
  if (ctx.user.saveStickyBucketAssignmentDoc && !experiment.disableStickyBucketing) {
    var _getStickyBucketVaria = getStickyBucketVariation({
        ctx: ctx,
        expKey: experiment.key,
        expBucketVersion: experiment.bucketVersion,
        expHashAttribute: experiment.hashAttribute,
        expFallbackAttribute: experiment.fallbackAttribute,
        expMinBucketVersion: experiment.minBucketVersion,
        expMeta: experiment.meta
      }),
      _variation = _getStickyBucketVaria.variation,
      versionIsBlocked = _getStickyBucketVaria.versionIsBlocked;
    foundStickyBucket = _variation >= 0;
    assigned = _variation;
    stickyBucketVersionIsBlocked = !!versionIsBlocked;
  }

  // Some checks are not needed if we already have a sticky bucket
  if (!foundStickyBucket) {
    // 7. Exclude if user is filtered out (used to be called "namespace")
    if (experiment.filters) {
      if (isFilteredOut(experiment.filters, ctx)) {
        process.env.NODE_ENV !== "production" && ctx.global.log("Skip because of filters", {
          id: key
        });
        return {
          result: getExperimentResult(ctx, experiment, -1, false, featureId)
        };
      }
    } else if (experiment.namespace && !inNamespace(hashValue, experiment.namespace)) {
      process.env.NODE_ENV !== "production" && ctx.global.log("Skip because of namespace", {
        id: key
      });
      return {
        result: getExperimentResult(ctx, experiment, -1, false, featureId)
      };
    }

    // 7.5. Exclude if experiment.include returns false or throws
    if (experiment.include && !isIncluded(experiment.include)) {
      process.env.NODE_ENV !== "production" && ctx.global.log("Skip because of include function", {
        id: key
      });
      return {
        result: getExperimentResult(ctx, experiment, -1, false, featureId)
      };
    }

    // 8. Exclude if condition is false
    if (experiment.condition && !conditionPasses(experiment.condition, ctx)) {
      process.env.NODE_ENV !== "production" && ctx.global.log("Skip because of condition exp", {
        id: key
      });
      return {
        result: getExperimentResult(ctx, experiment, -1, false, featureId)
      };
    }

    // 8.05. Exclude if prerequisites are not met
    if (experiment.parentConditions) {
      var evaluatedFeatures = new Set(ctx.stack.evaluatedFeatures);
      var _iterator3 = _createForOfIteratorHelper(experiment.parentConditions),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var parentCondition = _step3.value;
          ctx.stack.evaluatedFeatures = new Set(evaluatedFeatures);
          var parentResult = evalFeature(parentCondition.id, ctx);
          // break out for cyclic prerequisites
          if (parentResult.source === "cyclicPrerequisite") {
            return {
              result: getExperimentResult(ctx, experiment, -1, false, featureId)
            };
          }
          var evalObj = {
            value: parentResult.value
          };
          if (!evalCondition(evalObj, parentCondition.condition || {})) {
            process.env.NODE_ENV !== "production" && ctx.global.log("Skip because prerequisite evaluation fails", {
              id: key
            });
            return {
              result: getExperimentResult(ctx, experiment, -1, false, featureId)
            };
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }

    // 8.1. Exclude if user is not in a required group
    if (experiment.groups && !hasGroupOverlap(experiment.groups, ctx)) {
      process.env.NODE_ENV !== "production" && ctx.global.log("Skip because of groups", {
        id: key
      });
      return {
        result: getExperimentResult(ctx, experiment, -1, false, featureId)
      };
    }
  }

  // 8.2. Old style URL targeting
  if (experiment.url && !urlIsValid(experiment.url, ctx)) {
    process.env.NODE_ENV !== "production" && ctx.global.log("Skip because of url", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 9. Get the variation from the sticky bucket or get bucket ranges and choose variation
  var n = hash(experiment.seed || key, hashValue, experiment.hashVersion || 1);
  if (n === null) {
    process.env.NODE_ENV !== "production" && ctx.global.log("Skip because of invalid hash version", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }
  if (!foundStickyBucket) {
    var ranges = experiment.ranges || getBucketRanges(numVariations, experiment.coverage === undefined ? 1 : experiment.coverage, experiment.weights);
    assigned = chooseVariation(n, ranges);
  }

  // 9.5 Unenroll if any prior sticky buckets are blocked by version
  if (stickyBucketVersionIsBlocked) {
    process.env.NODE_ENV !== "production" && ctx.global.log("Skip because sticky bucket version is blocked", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId, undefined, true)
    };
  }

  // 10. Return if not in experiment
  if (assigned < 0) {
    process.env.NODE_ENV !== "production" && ctx.global.log("Skip because of coverage", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 11. Experiment has a forced variation
  if ("force" in experiment) {
    process.env.NODE_ENV !== "production" && ctx.global.log("Force variation", {
      id: key,
      variation: experiment.force
    });
    return {
      result: getExperimentResult(ctx, experiment, experiment.force === undefined ? -1 : experiment.force, false, featureId)
    };
  }

  // 12. Exclude if in QA mode
  if (ctx.global.qaMode || ctx.user.qaMode) {
    process.env.NODE_ENV !== "production" && ctx.global.log("Skip because QA mode", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 12.5. Exclude if experiment is stopped
  if (experiment.status === "stopped") {
    process.env.NODE_ENV !== "production" && ctx.global.log("Skip because stopped", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 13. Build the result object
  var result = getExperimentResult(ctx, experiment, assigned, true, featureId, n, foundStickyBucket);

  // 13.5. Persist sticky bucket
  if (ctx.user.saveStickyBucketAssignmentDoc && !experiment.disableStickyBucketing) {
    var _generateStickyBucket = generateStickyBucketAssignmentDoc(ctx, hashAttribute, toString(hashValue), _defineProperty({}, getStickyBucketExperimentKey(experiment.key, experiment.bucketVersion), result.key)),
      changed = _generateStickyBucket.changed,
      attrKey = _generateStickyBucket.key,
      doc = _generateStickyBucket.doc;
    if (changed) {
      // update local docs
      ctx.user.stickyBucketAssignmentDocs = ctx.user.stickyBucketAssignmentDocs || {};
      ctx.user.stickyBucketAssignmentDocs[attrKey] = doc;
      // save doc
      ctx.user.saveStickyBucketAssignmentDoc(doc);
    }
  }

  // 14. Fire the tracking callback(s)
  // Store the promise in case we're awaiting it (ex: browser url redirects)
  var trackingCalls = onExperimentViewed(ctx, experiment, result);
  if (trackingCalls.length === 0 && ctx.global.saveDeferredTrack) {
    ctx.global.saveDeferredTrack({
      experiment: experiment,
      result: result
    });
  }
  var trackingCall = !trackingCalls.length ? undefined : trackingCalls.length === 1 ? trackingCalls[0] : Promise.all(trackingCalls).then(function () {});

  // 14.1 Keep track of completed changeIds
  "changeId" in experiment && experiment.changeId && ctx.global.recordChangeId && ctx.global.recordChangeId(experiment.changeId);

  // 15. Return the result
  process.env.NODE_ENV !== "production" && ctx.global.log("In experiment", {
    id: key,
    variation: result.variationId
  });
  return {
    result: result,
    trackingCall: trackingCall
  };
}
function getFeatureResult(ctx, key, value, source, ruleId, experiment, result) {
  var ret = {
    value: value,
    on: !!value,
    off: !value,
    source: source,
    ruleId: ruleId || ""
  };
  if (experiment) ret.experiment = experiment;
  if (result) ret.experimentResult = result;

  // Track the usage of this feature in real-time
  if (source !== "override") {
    onFeatureUsage(ctx, key, ret);
  }
  return ret;
}
function getAttributes(ctx) {
  return _objectSpread(_objectSpread({}, ctx.user.attributes), ctx.user.attributeOverrides);
}
function conditionPasses(condition, ctx) {
  return evalCondition(getAttributes(ctx), condition, ctx.global.savedGroups || {});
}
function isFilteredOut(filters, ctx) {
  return filters.some(function (filter) {
    var _getHashAttribute2 = getHashAttribute(ctx, filter.attribute),
      hashValue = _getHashAttribute2.hashValue;
    if (!hashValue) return true;
    var n = hash(filter.seed, hashValue, filter.hashVersion || 2);
    if (n === null) return true;
    return !filter.ranges.some(function (r) {
      return inRange(n, r);
    });
  });
}
function isIncludedInRollout(ctx, seed, hashAttribute, fallbackAttribute, range, coverage, hashVersion) {
  if (!range && coverage === undefined) return true;
  if (!range && coverage === 0) return false;
  var _getHashAttribute3 = getHashAttribute(ctx, hashAttribute, fallbackAttribute),
    hashValue = _getHashAttribute3.hashValue;
  if (!hashValue) {
    return false;
  }
  var n = hash(seed, hashValue, hashVersion || 1);
  if (n === null) return false;
  return range ? inRange(n, range) : coverage !== undefined ? n <= coverage : true;
}
export function getExperimentResult(ctx, experiment, variationIndex, hashUsed, featureId, bucket, stickyBucketUsed) {
  var inExperiment = true;
  // If assigned variation is not valid, use the baseline and mark the user as not in the experiment
  if (variationIndex < 0 || variationIndex >= experiment.variations.length) {
    variationIndex = 0;
    inExperiment = false;
  }
  var _getHashAttribute4 = getHashAttribute(ctx, experiment.hashAttribute, ctx.user.saveStickyBucketAssignmentDoc && !experiment.disableStickyBucketing ? experiment.fallbackAttribute : undefined),
    hashAttribute = _getHashAttribute4.hashAttribute,
    hashValue = _getHashAttribute4.hashValue;
  var meta = experiment.meta ? experiment.meta[variationIndex] : {};
  var res = {
    key: meta.key || "" + variationIndex,
    featureId: featureId,
    inExperiment: inExperiment,
    hashUsed: hashUsed,
    variationId: variationIndex,
    value: experiment.variations[variationIndex],
    hashAttribute: hashAttribute,
    hashValue: hashValue,
    stickyBucketUsed: !!stickyBucketUsed
  };
  if (meta.name) res.name = meta.name;
  if (bucket !== undefined) res.bucket = bucket;
  if (meta.passthrough) res.passthrough = meta.passthrough;
  return res;
}
function mergeOverrides(experiment, ctx) {
  var key = experiment.key;
  var o = ctx.global.overrides;
  if (o && o[key]) {
    experiment = Object.assign({}, experiment, o[key]);
    if (typeof experiment.url === "string") {
      experiment.url = getUrlRegExp(
      // eslint-disable-next-line
      experiment.url);
    }
  }
  return experiment;
}
export function getHashAttribute(ctx, attr, fallback) {
  var hashAttribute = attr || "id";
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var hashValue = "";
  var attributes = getAttributes(ctx);
  if (attributes[hashAttribute]) {
    hashValue = attributes[hashAttribute];
  }

  // if no match, try fallback
  if (!hashValue && fallback) {
    if (attributes[fallback]) {
      hashValue = attributes[fallback];
    }
    if (hashValue) {
      hashAttribute = fallback;
    }
  }
  return {
    hashAttribute: hashAttribute,
    hashValue: hashValue
  };
}
function urlIsValid(urlRegex, ctx) {
  var url = ctx.user.url;
  if (!url) return false;
  var pathOnly = url.replace(/^https?:\/\//, "").replace(/^[^/]*\//, "/");
  if (urlRegex.test(url)) return true;
  if (urlRegex.test(pathOnly)) return true;
  return false;
}
function hasGroupOverlap(expGroups, ctx) {
  var groups = ctx.global.groups || {};
  for (var i = 0; i < expGroups.length; i++) {
    if (groups[expGroups[i]]) return true;
  }
  return false;
}
function getStickyBucketVariation(_ref) {
  var ctx = _ref.ctx,
    expKey = _ref.expKey,
    expBucketVersion = _ref.expBucketVersion,
    expHashAttribute = _ref.expHashAttribute,
    expFallbackAttribute = _ref.expFallbackAttribute,
    expMinBucketVersion = _ref.expMinBucketVersion,
    expMeta = _ref.expMeta;
  expBucketVersion = expBucketVersion || 0;
  expMinBucketVersion = expMinBucketVersion || 0;
  expHashAttribute = expHashAttribute || "id";
  expMeta = expMeta || [];
  var id = getStickyBucketExperimentKey(expKey, expBucketVersion);
  var assignments = getStickyBucketAssignments(ctx, expHashAttribute, expFallbackAttribute);

  // users with any blocked bucket version (0 to minExperimentBucketVersion) are excluded from the test
  if (expMinBucketVersion > 0) {
    for (var i = 0; i <= expMinBucketVersion; i++) {
      var blockedKey = getStickyBucketExperimentKey(expKey, i);
      if (assignments[blockedKey] !== undefined) {
        return {
          variation: -1,
          versionIsBlocked: true
        };
      }
    }
  }
  var variationKey = assignments[id];
  if (variationKey === undefined)
    // no assignment found
    return {
      variation: -1
    };
  var variation = expMeta.findIndex(function (m) {
    return m.key === variationKey;
  });
  if (variation < 0)
    // invalid assignment, treat as "no assignment found"
    return {
      variation: -1
    };
  return {
    variation: variation
  };
}
function getStickyBucketExperimentKey(experimentKey, experimentBucketVersion) {
  experimentBucketVersion = experimentBucketVersion || 0;
  return "".concat(experimentKey, "__").concat(experimentBucketVersion);
}
export function getStickyBucketAttributeKey(attributeName, attributeValue) {
  return "".concat(attributeName, "||").concat(attributeValue);
}
function getStickyBucketAssignments(ctx, expHashAttribute, expFallbackAttribute) {
  if (!ctx.user.stickyBucketAssignmentDocs) return {};
  var _getHashAttribute5 = getHashAttribute(ctx, expHashAttribute),
    hashAttribute = _getHashAttribute5.hashAttribute,
    hashValue = _getHashAttribute5.hashValue;
  var hashKey = getStickyBucketAttributeKey(hashAttribute, toString(hashValue));
  var _getHashAttribute6 = getHashAttribute(ctx, expFallbackAttribute),
    fallbackAttribute = _getHashAttribute6.hashAttribute,
    fallbackValue = _getHashAttribute6.hashValue;
  var fallbackKey = fallbackValue ? getStickyBucketAttributeKey(fallbackAttribute, toString(fallbackValue)) : null;
  var assignments = {};
  if (fallbackKey && ctx.user.stickyBucketAssignmentDocs[fallbackKey]) {
    Object.assign(assignments, ctx.user.stickyBucketAssignmentDocs[fallbackKey].assignments || {});
  }
  if (ctx.user.stickyBucketAssignmentDocs[hashKey]) {
    Object.assign(assignments, ctx.user.stickyBucketAssignmentDocs[hashKey].assignments || {});
  }
  return assignments;
}
function generateStickyBucketAssignmentDoc(ctx, attributeName, attributeValue, assignments) {
  var key = getStickyBucketAttributeKey(attributeName, attributeValue);
  var existingAssignments = ctx.user.stickyBucketAssignmentDocs && ctx.user.stickyBucketAssignmentDocs[key] ? ctx.user.stickyBucketAssignmentDocs[key].assignments || {} : {};
  var newAssignments = _objectSpread(_objectSpread({}, existingAssignments), assignments);
  var changed = JSON.stringify(existingAssignments) !== JSON.stringify(newAssignments);
  return {
    key: key,
    doc: {
      attributeName: attributeName,
      attributeValue: attributeValue,
      assignments: newAssignments
    },
    changed: changed
  };
}
function deriveStickyBucketIdentifierAttributes(ctx, data) {
  var attributes = new Set();
  var features = data && data.features ? data.features : ctx.global.features || {};
  var experiments = data && data.experiments ? data.experiments : ctx.global.experiments || [];
  Object.keys(features).forEach(function (id) {
    var feature = features[id];
    if (feature.rules) {
      var _iterator4 = _createForOfIteratorHelper(feature.rules),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var rule = _step4.value;
          if (rule.variations) {
            attributes.add(rule.hashAttribute || "id");
            if (rule.fallbackAttribute) {
              attributes.add(rule.fallbackAttribute);
            }
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  });
  experiments.map(function (experiment) {
    attributes.add(experiment.hashAttribute || "id");
    if (experiment.fallbackAttribute) {
      attributes.add(experiment.fallbackAttribute);
    }
  });
  return Array.from(attributes);
}
export function getAllStickyBucketAssignmentDocs(_x2, _x3, _x4) {
  return _getAllStickyBucketAssignmentDocs.apply(this, arguments);
}
function _getAllStickyBucketAssignmentDocs() {
  _getAllStickyBucketAssignmentDocs = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(ctx, stickyBucketService, data) {
    var attributes;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          attributes = getStickyBucketAttributes(ctx, data);
          return _context2.a(2, stickyBucketService.getAllAssignments(attributes));
      }
    }, _callee2);
  }));
  return _getAllStickyBucketAssignmentDocs.apply(this, arguments);
}
export function getStickyBucketAttributes(ctx, data) {
  var attributes = {};
  var stickyBucketIdentifierAttributes = deriveStickyBucketIdentifierAttributes(ctx, data);
  stickyBucketIdentifierAttributes.forEach(function (attr) {
    var _getHashAttribute7 = getHashAttribute(ctx, attr),
      hashValue = _getHashAttribute7.hashValue;
    attributes[attr] = toString(hashValue);
  });
  return attributes;
}
export function decryptPayload(_x5, _x6, _x7) {
  return _decryptPayload.apply(this, arguments);
}
function _decryptPayload() {
  _decryptPayload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(data, decryptionKey, subtle) {
    var _t2, _t3, _t4, _t5, _t6, _t7, _t8, _t9, _t0;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          data = _objectSpread({}, data);
          if (!data.encryptedFeatures) {
            _context3.n = 5;
            break;
          }
          _context3.p = 1;
          _t2 = JSON;
          _context3.n = 2;
          return decrypt(data.encryptedFeatures, decryptionKey, subtle);
        case 2:
          _t3 = _context3.v;
          data.features = _t2.parse.call(_t2, _t3);
          _context3.n = 4;
          break;
        case 3:
          _context3.p = 3;
          _t4 = _context3.v;
          console.error(_t4);
        case 4:
          delete data.encryptedFeatures;
        case 5:
          if (!data.encryptedExperiments) {
            _context3.n = 10;
            break;
          }
          _context3.p = 6;
          _t5 = JSON;
          _context3.n = 7;
          return decrypt(data.encryptedExperiments, decryptionKey, subtle);
        case 7:
          _t6 = _context3.v;
          data.experiments = _t5.parse.call(_t5, _t6);
          _context3.n = 9;
          break;
        case 8:
          _context3.p = 8;
          _t7 = _context3.v;
          console.error(_t7);
        case 9:
          delete data.encryptedExperiments;
        case 10:
          if (!data.encryptedSavedGroups) {
            _context3.n = 15;
            break;
          }
          _context3.p = 11;
          _t8 = JSON;
          _context3.n = 12;
          return decrypt(data.encryptedSavedGroups, decryptionKey, subtle);
        case 12:
          _t9 = _context3.v;
          data.savedGroups = _t8.parse.call(_t8, _t9);
          _context3.n = 14;
          break;
        case 13:
          _context3.p = 13;
          _t0 = _context3.v;
          console.error(_t0);
        case 14:
          delete data.encryptedSavedGroups;
        case 15:
          return _context3.a(2, data);
      }
    }, _callee3, null, [[11, 13], [6, 8], [1, 3]]);
  }));
  return _decryptPayload.apply(this, arguments);
}
export function getApiHosts(options) {
  var defaultHost = options.apiHost || "https://cdn.growthbook.io";
  return {
    apiHost: defaultHost.replace(/\/*$/, ""),
    streamingHost: (options.streamingHost || defaultHost).replace(/\/*$/, ""),
    apiRequestHeaders: options.apiHostRequestHeaders,
    streamingHostRequestHeaders: options.streamingHostRequestHeaders
  };
}
export function getExperimentDedupeKey(experiment, result) {
  return result.hashAttribute + result.hashValue + experiment.key + result.variationId;
}